const { instance } = require('./url')

async function getBacklog() {
    return await instance.get('/backlog')
}

async function getBacklogs(quoteId) {
    return await instance.get('/backlog/' + quoteId)
}

async function getBacklogReport(backlog) {
    return await instance.get('/backlog/report/' + backlog)
}

async function getBacklogJobSearch(searchModel) {
    return await instance.post('/backlog/search', {
        'search': searchModel,
    })
}

async function updateBacklogs(backlogs) {
    return await instance.put('/backlog', {
        'backlogs': backlogs,
    })
}

async function updateBacklogsWithOrginal(originalBacklogs, backlogs, quoteId=null) {
    const sendingBacklogs = []
    for (let i = 0; i < originalBacklogs.length; i++) {
        if (!originalBacklogs[i].equalTo(backlogs[i])) {
            if (originalBacklogs[i].is_checked && backlogs[i].is_checked) {
                const newB = originalBacklogs[i].copy()
                newB.is_checked = false
                sendingBacklogs.push(newB)
            }

            const newB = backlogs[i].copy()
            if (!newB.quote_id && quoteId) {
                newB.quote_id = quoteId
            }
            sendingBacklogs.push(newB)
        }
    }

    if (sendingBacklogs.length === 0) {
        return { data: { backlogs: [] } }
    }

    return await instance.put('/backlog', {
        'backlogs': sendingBacklogs,
    })
}

export {
    getBacklog, getBacklogs,
    getBacklogReport,
    updateBacklogs, updateBacklogsWithOrginal,
    getBacklogJobSearch,
}

